import { render, staticRenderFns } from "./upload-profile-photo.vue?vue&type=template&id=4f740504"
import script from "./upload-profile-photo.vue?vue&type=script&lang=js"
export * from "./upload-profile-photo.vue?vue&type=script&lang=js"
import style0 from "./upload-profile-photo.vue?vue&type=style&index=0&id=4f740504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports